import React from 'react'

export default function Riskassessment() {
  return (
    <>
    <div className='md:px-10 px-5 overflow-hidden'>
        <div className='max-w-screen-xl mx-auto justify-center'>
            <div className='py-10 md:pt-20'>
                <h1 className='md:text-4xl text-xl mx-auto text-[#000] justify-center'>
                    Incident Response
                </h1>
                <h3 className='text-[#000000] md:text-xl text-base pt-5'>
                    Minimizing Impact, Ensuring Continuity
                </h3>
                <p className='text-[#474747] md:text-base text-sm pt-3'>
                    In the event of a cyber incident, Elite Crown Diamond' rapid and coordinated incident response services are designed to minimize impact and swiftly restore operations.
                </p>
            </div>

            <div className=''>
                <div className='justify-center w-full mx-auto text-[#000]'>
                    <h1 className='md:text-2xl text-xl mx-auto text-[#000] justify-center'>
                        Key Features:
                    </h1>
                    <div className='md:grid grid-cols-2 md:gap-x-10 justify-between mx-auto mt-3'>
                        <div className='md:py-10 hover:bg-white duration-200 border-opacity-40 py-5 border-b border-[#d8bb6c] hover:translate-y-1 hover:px-5 hover:text-black cursor-wait'>
                            <span className='font-semibold md:text-xl text-lg border-b border-[#d8bb6c]'>
                                Immediate Response:
                            </span>
                            <p className='text-[#474747] md:text-base text-sm pt-3 hover:text-black'>
                                Our team initiates a swift response to security incidents, reducing downtime and mitigating potential damage.
                            </p>
                        </div>
                        <div className='md:py-10 hover:bg-white duration-200 border-opacity-40 py-5 border-b border-[#d8bb6c] hover:translate-y-1 hover:px-5 hover:text-black cursor-wait'>
                            <span className='font-semibold md:text-xl text-lg border-b border-[#d8bb6c]'>
                                Incident Analysis:
                            </span>
                            <p className='text-[#474747] md:text-base text-sm pt-3 hover:text-black'>
                                Comprehensive analysis to understand the scope, method, and source of the attack, ensuring targeted and effective countermeasures.
                            </p>
                        </div>
                        <div className='md:py-10 hover:bg-white duration-200 border-opacity-40 py-5 border-b border-[#d8bb6c] hover:translate-y-1 hover:px-5 hover:text-black cursor-wait'>
                            <span className='font-semibold md:text-xl text-lg border-b border-[#d8bb6c]'>
                                Recovery and Restoration:
                            </span>
                            <p className='text-[#474747] md:text-base text-sm pt-3 hover:text-black'>
                                Quick restoration of affected systems and data to resume business operations with minimal disruption.
                            </p>
                        </div>
                        <div className='md:py-10 hover:bg-white duration-200 border-opacity-40 py-5 border-b border-[#d8bb6c] hover:translate-y-1 hover:px-5 hover:text-black cursor-wait'>
                            <span className='font-semibold md:text-xl text-lg border-b border-[#d8bb6c]'>
                                Post-Incident Review:
                            </span>
                            <p className='text-[#474747] md:text-base text-sm pt-3 hover:text-black'>
                                Detailed incident reports and reviews to identify lessons learned and strengthen future defenses.
                            </p>
                        </div>
                    </div>
                    <div className='justify-center mx-auto w-full bg-[#e4e4e4] px-5 md:mt-10 mt-5'>
                        <div className='text-[#1a1a1a] max-w-screen-xl mx-auto justify-center md:py-20 py-10 text-center md:text-xl text-xs'>
                            <p>
                            By integrating these critical cybersecurity services into your operations, Elite Crown Diamond empowers your business to operate securely, confidently, and in full compliance with regulatory standards.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    </>
  )
}